module.exports = __webpack_public_path__ + "assets/70b23b96c63c311de839dde6de5eeac4.mp3";